"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ImageUploadContainer = exports.ImageUploadButton = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _templateObject, _templateObject2;
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
var ImageUploadContainer = exports.ImageUploadContainer = _styledComponents["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n  margin: 0 var(--spacing-1) var(--spacing-0-5) 0;\n  transition-property: width, opacity;\n  transition-duration: var(--transition-delay-1);\n  transition-timing-function: ease-out;\n  width: ", ";\n  opacity: ", ";\n  overflow: hidden;\n"])), function (_ref) {
  var isImageUploadEnabled = _ref.isImageUploadEnabled;
  return isImageUploadEnabled ? '40px' : '0';
}, function (_ref2) {
  var isImageUploadEnabled = _ref2.isImageUploadEnabled;
  return isImageUploadEnabled ? '1' : '0';
});
var ImageUploadButton = exports.ImageUploadButton = _styledComponents["default"].input(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  opacity: 0;\n  cursor: pointer;\n"])));